<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { HfarmCorporate } from "../../modules/hfarm_corporate_module.js";
import VueButton from "vue-button";

export default {
  mixins: [fandomBasicMixin],
  components: {
    VueButton
  },
  created() {
    if (this.content.theme) {
      this.content.stripes.forEach((stripe) => {
        if (!Fandom.exists(stripe.theme)) {
          Vue.set(stripe, "theme", this.content.theme);
        }
      });
    }
  },
  mounted() {
    Vue.nextTick(() => {
      this.registerAnimation();
    });
  },
  computed: {
    headerImage() {
      return this.content.image ? Fandom.getBackgroundUrl(this.content.image.url) : 'none';
    },
    title() {
      if (this.content.title) {
        return this.content.title;
      }
      if (globalState.pageModel.seo && globalState.pageModel.seo.title) {
        return globalState.pageModel.seo.title.split('|')[0];
      } else {
        const mainContentName = globalState.pageModel.main_content_name;
        return globalState.pageModel.name_to_content[mainContentName].title;
      }
    }
  },
  methods: {
    isTypeformUrl: HfarmCorporate.isTypeformUrl,
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="[contentType, `${this.content.theme}-theme`]" v-if="isContentVisibleToUser()" class="position-relative" page-with-image-header-component>
    <div class="position-relative header mh-50vh d-flex align-items-center overflow-hidden">
      <div class="position-absolute-center w-100 h-100 bg-cover-center inview_animate_zoom" :style="{'background-image': headerImage }"></div>
      <div class="layer position-absolute w-100 h-100"></div>
      <div class="container-fluid">
        <div class="row my-4 justify-content-center">
          <div class="col-md-10 row mx-0 px-0 text-white">
            <div class="col-12 col-md-6">
              <img v-if="content.icon" :src="expandUrl(content.icon.url)" class="mb-4 header-icon" />
              <p class="category" v-if="content.category">{{content.category}}</p>
              <component :is="content.title_tag || 'h1'" class="display-2" v-if="content.title && !content.icon">{{title}}</component>
              <component :is="content.description_tag || 'div'" v-html="content.description" v-if="content.description"></component>
              <div v-if="content.button || content.buttons" class="align-btn-group my-4">
                <vue-button
                  tag="a"
                  v-if="content.button" 
                  :button="content.button"
                  class="m-2 my-2" 
                  :buttonClass="['btn shadow-none', getPrimaryButtonClass(content.button_class, 'dark')]"
                ></vue-button>
                <template v-if="content.buttons">
                  <vue-button
                    tag="a"
                    class="m-2"
                    :key="index" 
                    :button="buttonRecord.button"
                    v-for="(buttonRecord, index) in content.buttons" 
                    :class="['btn shadow-none', getPrimaryButtonClass(content.button_class, 'dark')]"
                  ></vue-button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <component :is="stripe.layout" :content="stripe" v-for="(stripe, index) in content.stripes" :key="stripe.$id" :opt-container-content="containerContent" :class="{'first': !index}"></component>
  </div>
</template>

<style lang="scss">
[page-with-image-header-component] {
  padding-bottom: 1px;

  .header.mh-100vh-header {
    min-height: calc(100vh - #{$header-height} - #{$auxiliary-navbar-height});
  }

  .header.h-100vh-header {
    height: calc(100vh - #{$header-height} - #{$auxiliary-navbar-height});
  }

  .header-icon {
    width: 15rem;
    max-width: 50%;
  }
}
</style>
